
import { Base } from '../base-component';
import './add-on.component.scss';

export class AddOn extends Base {

	constructor(element: Element){

		super(element);

	}

	init(){

	}

	bindEvents() {

	}
}


// WEBPACK FOOTER //
// ./components/add-on/add-on.component.ts